import React from "react";

import svg from "../../assets/images/icons/date_equal_to.svg";

export const DateEqualToIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Date Equal To"}
    />
);
